<template>
    <div>
        <div>
            <v-select
                inputId="assign-to-intent"
                v-model="selectedIntent"
                :options="intentList"
                :close-on-select="true"
                label="display_name"
                class="mw-100"
                :placeholder="placeholder"
                :taggable="true"
                :create-option="createIntentOption"
                v-on:input="emitUpdate(selectedIntent)"
            >
                <template slot="option" slot-scope="option">
                    <span v-if="option.name">{{ option.display_name }}</span>
                    <span v-else
                        >Create new intent <span class="font-weight-bold">"{{ option.display_name }}"</span></span
                    >
                </template>
                <template v-slot:selected-option="option">
                    <span v-if="!option.name" class="badge badge-gray mr-2">New Intent</span>
                    {{ option.display_name }}
                </template>
                <template slot="no-options">
                    <div class="py-2">
                        <span class="text-secondary">No intents created yet.</span>
                    </div>
                </template>
            </v-select>
        </div>
        <div v-if="selectedIntent && !selectedIntent.name" class="mt-2">
            <input
                v-model="selectedIntent.response"
                v-on:input="emitUpdate(selectedIntent)"
                type="text"
                class="form-control"
                placeholder="How should the agent have responded?"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ChatIntentSelector",
    props: {
        value: {
            type: Object,
            required: false,
        },
        intentList: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        placeholder: {
            type: String,
            required: false,
            default: "Select or create a new intent...",
        },
    },
    data() {
        return {
            selectedIntent: this.value,
        }
    },
    watch: {
        value: function (newValue) {
            this.selectedIntent = newValue
        },
    },
    methods: {
        createIntentOption(newOption) {
            return {
                display_name: newOption,
                label: newOption,
                isNew: true,
            }
        },
        emitUpdate(value) {
            this.$emit("input", value)
        },
    },
}
</script>

<style>
</style>